import * as yup from 'yup';

import i18n from '@app/i18n/config';

import { OWN_COOPERATION_REASON_KEY, OWN_REASON_MAX_LENGTH } from './constants';

const multipleChoiceRequired = i18n.t(
  'REGISTRATION_QUESTIONARY:insuranceAgentExperienceDetailsForm.errors.multipleChoiceRequired'
);
const singleChoiceRequired = i18n.t(
  'REGISTRATION_QUESTIONARY:insuranceAgentExperienceDetailsForm.errors.singleChoiceRequired'
);
const ownReasonRequired = i18n.t(
  'REGISTRATION_QUESTIONARY:insuranceAgentExperienceDetailsForm.errors.ownReasonRequired'
);
const ownCooperationReason = i18n.t(
  `REGISTRATION_QUESTIONARY:${OWN_COOPERATION_REASON_KEY}`
);

const optionSchema = yup.object({
  name: yup.string().required(),
  isSelected: yup.boolean().required(),
});

const hasSelectedOption = (
  options?: Array<{ isSelected?: boolean } | undefined>
) => options?.some((option) => option?.isSelected) ?? false;

export const insuranceAgentExperienceDetailsFormSchema = yup
  .object({
    typesInsurance: yup
      .array()
      .of(optionSchema)
      .required(multipleChoiceRequired)
      .test('has-selected-option', multipleChoiceRequired, hasSelectedOption),
    avgSalesVolume: yup.string().required(singleChoiceRequired),
    acquisitionChannel: yup.string().required(singleChoiceRequired),
    reasonCooperation: yup
      .array()
      .of(
        optionSchema.shape({
          description: yup
            .string()
            .trim()
            .max(OWN_REASON_MAX_LENGTH, i18n.t('COMMON:errors.maxLength'))
            .when(['name', 'isSelected'], {
              is: (name: string, isSelected: boolean) =>
                name === ownCooperationReason && isSelected,
              then: (schema) => schema.required(ownReasonRequired),
            }),
        })
      )
      .required(multipleChoiceRequired)
      .test('has-selected-option', multipleChoiceRequired, hasSelectedOption),
  })
  .required();
